module.exports = __webpack_public_path__ + "img/icon60.79e99c10.png";